import { useState } from "react";
import { useEffect, useRef } from "react";

const StatusSelector = ({ value, Data, handleChange, item }) => {
  const [isFalse, setIsFalse] = useState(false);
  const [InitValue, setInitValue] = useState(value);
  const [StatusData, setStatusData] = useState(Data);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    console.log("value", value);
    console.log("data", Data);
    console.log("handleChange", handleChange);



    console.log("item", item);
  }, []);
  const handleSubmit = (selection) => {
    setInitValue(selection);
    setIsFalse(false);
    handleChange(selection, item);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setInputValue(value);

    const filteredData = Data.filter(
      (item) => item.title && item.title.toLowerCase().includes(value)
    );
    setStatusData(filteredData);
  };

  function useClickOutside(callback) {
    const ref = useRef();

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [callback, StatusData]);

    return ref;
  }

  const ref = useClickOutside(() => {
    setIsFalse(false);
  });

  return (
    <div ref={ref}>
      {!isFalse ? (
        <span
          onClick={() => setIsFalse(!isFalse)}
          style={{
            fontSize: "13px",
            fontWeight: "600",
            backgroundColor: `${InitValue?.color_code}`,
            maxWidth: "150px",
            minWidth: "150px",
          }}
          className="badge w-100"
        >
          {InitValue?.title}
        </span>
      ) : (
        <div className="card" style={{ maxWidth: "175px" }}>
          <input
            type="text"
            placeholder="Search..."
            value={inputValue}
            onChange={handleSearch}
          />
          <div
            className="d-flex flex-column selectionContentArea"
            style={{ overflow: "auto" }}
          >
            {StatusData.length > 0 ? (
              StatusData.map((item, index) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => handleSubmit(item)}
                    className="px-2 py-1 hover_effect pointer"
                    style={{ fontSize: "15px", fontWeight: "400" }}
                  >
                    <span key={item.id}>{item?.title}</span>
                  </div>
                );
              })
            ) : (
              <div
                className="px-2 py-1 hover_effect pointer"
                style={{ fontSize: "15px", fontWeight: "400" }}
              >
                <span>No data.</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusSelector;
